import { render, staticRenderFns } from "./Number.vue.js?vue&type=template&id=24a793c9!=!../vue-loader/lib/index.js??vue-loader-options!./Number.vue?vue&type=template&id=24a793c9"
import script from "./Number.vue.js?vue&type=script&lang=js!=!../vue-loader/lib/index.js??vue-loader-options!./Number.vue?vue&type=script&lang=js"
export * from "./Number.vue.js?vue&type=script&lang=js!=!../vue-loader/lib/index.js??vue-loader-options!./Number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports